import { useState } from "react";
import AuditChangesModal from "../AuditChangesModal";

function AuditTable({ logs }) {
  const [selectedLog, setSelectedLog] = useState(null);

  return (
    <div className="overflow-x-auto bg-white rounded shadow">
      <table className="min-w-full text-sm">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-3">ID</th>
            <th className="p-3">Module</th>
            <th className="p-3">Record</th>
            <th className="p-3">Action</th>
            <th className="p-3">User</th>
            <th className="p-3">Date</th>
            <th className="p-3">Changes</th>
          </tr>
        </thead>
        <tbody>
          {logs.map(log => (
            <tr key={log.id} className="border-t hover:bg-gray-50">
              <td className="p-3">{log.id}</td>
              <td className="p-3">{log.module_name}</td>
              <td className="p-3">{log.record_id}</td>
              <td className="p-3">{log.action}</td>
              <td className="p-3">{log.performed_by}</td>
              <td className="p-3">{new Date(log.created_at).toLocaleString()}</td>
              <td className="p-3">
                <button
                  className="text-blue-600"
                  onClick={() => setSelectedLog(log)}
                >
                  View
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {selectedLog && (
        <AuditChangesModal log={selectedLog} close={() => setSelectedLog(null)} />
      )}
    </div>
  );
}

export default AuditTable;